import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase, apiGeneratorBaseWithOnSuccess } from "../../Utils/saga"
import Creators, { AdminInvoicesTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getAdminInvoicesFilterOptionsActions: {
    request: Creators.getAdminInvoicesFilterOptionsRequest,
    success: Creators.getAdminInvoicesFilterOptionsSuccess,
    errors: Creators.getAdminInvoicesFilterOptionsFailure
  },
  getAdminInvoicesActions: {
    request: Creators.getAdminInvoicesRequest,
    success: Creators.getAdminInvoicesSuccess,
    errors: Creators.adminInvoicesFailure
  },
  getAdminInvoicesExportActions: {
    request: Creators.getAdminInvoicesExportRequest,
    success: Creators.getAdminInvoicesExportSuccess,
    errors: Creators.getAdminInvoicesExportFailure
    //downloadFile: true,
  },
  updateAdminInvoiceActions: {
    request: Creators.updateAdminInvoiceRequest,
    success: Creators.updateAdminInvoiceSuccess,
    errors: Creators.adminInvoicesFailure
  },
  confirmInvoiceActions: {
    request: Creators.confirmInvoiceRequest,
    success: Creators.confirmInvoiceSuccess,
    errors: Creators.adminInvoicesFailure
  },
  changeInvoiceAmountActions: {
    request: Creators.changeInvoiceAmountRequest,
    success: Creators.changeInvoiceAmountSuccess,
    errors: Creators.adminInvoicesFailure
  }
}

const eventsOptions = {
  [constants.GET_ADMIN_INVOICES_FILTER_OPTIONS_REQUEST]: {
    api: services.getAdminInvoicesFilterOptions,
    actions: actions.getAdminInvoicesFilterOptionsActions
  },
  [constants.GET_ADMIN_INVOICES_REQUEST]: {
    api: services.getAdminInvoices,
    actions: actions.getAdminInvoicesActions
  },
  [constants.GET_ADMIN_INVOICES_EXPORT_REQUEST]: {
    api: services.getAdminInvoicesExport,
    actions: actions.getAdminInvoicesExportActions
  },
  [constants.UPDATE_ADMIN_INVOICE_REQUEST]: {
    api: services.updateAdminInvoice,
    actions: actions.updateAdminInvoiceActions
  },
  [constants.CONFIRM_INVOICE_REQUEST]: {
    api: services.confirmInvoice,
    actions: actions.confirmInvoiceActions
  },
  [constants.CHANGE_INVOICE_AMOUNT_REQUEST]: {
    api: services.changeInvoiceAmount,
    actions: actions.changeInvoiceAmountActions
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_ADMIN_INVOICES_FILTER_OPTIONS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_INVOICES_FILTER_OPTIONS_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_INVOICES_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_INVOICES_REQUEST])
  )
  yield takeLatest(constants.GET_ADMIN_INVOICES_EXPORT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_ADMIN_INVOICES_EXPORT_REQUEST])
  )
  yield takeLatest(constants.UPDATE_ADMIN_INVOICE_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.UPDATE_ADMIN_INVOICE_REQUEST])
  )
  yield takeLatest(constants.CONFIRM_INVOICE_REQUEST, (action) =>
    apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.CONFIRM_INVOICE_REQUEST])
  )
  yield takeLatest(constants.CHANGE_INVOICE_AMOUNT_REQUEST, (action) =>
    apiGeneratorBaseWithOnSuccess(action, eventsOptions[constants.CHANGE_INVOICE_AMOUNT_REQUEST])
  )
}
